import { APIS } from 'scbk-fund/constants/apiPaths';
import SvcFndActValidateFundSuitable from './kr/trading/SvcFndActValidateFundSuitable.json';

import HolFndMgtExecutePortfolioResult from './kr/insight/HolFndMgtExecutePortfolioResult.json';
import HolFndMgtGetAccountInfo from './kr/insight/HolFndMgtGetAccountInfo.json';
import HolFndMgtGetProductInfo from './kr/insight/HolFndMgtGetProductInfo.json';
import HolFndMgtListAccount from './kr/insight/HolFndMgtListAccount.json';
import HolFndMgtListCloseAccount from './kr/insight/HolFndMgtListCloseAccount.json';

import HolFndInqGetAccountRateOfReturn from './kr/management/HolFndInqGetAccountRateOfReturn.json';
import HolFndInqListAccountExcludeMMF from './kr/management/HolFndInqListAccountExcludeMMF.json';

import HolFndRdmExecuteTransferMain from './kr/trading/HolFndRdmExecuteTransferMain.json';
import HolFndRdmListAccount from './kr/trading/HolFndRdmListAccount.json';
import HolFndRdmValidateAccount from './kr/trading/HolFndRdmValidateAccount.json';

import SvcFndErdValidateAccount from './kr/expectedRedemption/SvcFndErdValidateAccount.json';
import HolFndInqDtlFundStatement from './kr/inquiry/HolFndInqDtlFundStatement.json';
import HolFndInqGetExpectedRedemption from './kr/inquiry/HolFndInqGetExpectedRedemption.json';
import HolFndInqInqAccountInfo from './kr/inquiry/HolFndInqInqAccountInfo.json';
import HolFndInqListAccountRateOfReturn from './kr/inquiry/HolFndInqListAccountRateOfReturn.json';
import HolFndInqLstAccoutData from './kr/inquiry/HolFndInqLstAccoutData.json';
import HolFndInqLstFundStatement from './kr/inquiry/HolFndInqLstFundStatement.json';
import UtlFncAccList from './kr/inquiry/UtlFncAccList.json';

import settingsCodeList from './kr/settingsCodeList.json';

export const MockConfig = {
    ['/auth/settings/code/list']: () => settingsCodeList,

    [APIS.holdings.funds.myfund.executePortfolioResult]: () => HolFndMgtExecutePortfolioResult,

    [APIS.holdings.funds.myfund.getAccountInfo]: () => HolFndMgtGetAccountInfo,

    [APIS.holdings.funds.myfund.getProductInfo]: () => HolFndMgtGetProductInfo,

    [APIS.holdings.funds.myfund.listAccount]: () => HolFndMgtListAccount,

    [APIS.holdings.funds.myfund.listCloseAccount]: () => HolFndMgtListCloseAccount,

    [APIS.holdings.funds.report.listAccountExcludeMMF]: () => HolFndInqListAccountExcludeMMF,

    [APIS.holdings.funds.report.getAccountRateOfReturn]: () => HolFndInqGetAccountRateOfReturn,

    [APIS.services.funds.targetAutomaticRedemption.listAccount]: () => HolFndRdmListAccount,

    [APIS.services.funds.targetAutomaticRedemption.validateAccount]: () => HolFndRdmValidateAccount,

    [APIS.services.funds.targetAutomaticRedemption.executeTransferMain]: () =>
        HolFndRdmExecuteTransferMain,

    [APIS.services.funds.additionalContribution.validateFundSuitable]: () =>
        SvcFndActValidateFundSuitable,

    [APIS.utilities.functions.account.list]: () => UtlFncAccList,
    [APIS.holdings.funds.inquiry.listAccountRateOfReturn]: () => HolFndInqListAccountRateOfReturn,
    [APIS.holdings.funds.inquiry.listAccountTransaction]: () => HolFndInqLstAccoutData,
    [APIS.holdings.funds.inquiry.listFundStatement]: () => HolFndInqLstFundStatement,
    [APIS.holdings.funds.inquiry.getFundStatement]: () => HolFndInqDtlFundStatement,
    [APIS.holdings.funds.inquiry.getAccountInfo]: () => HolFndInqInqAccountInfo,
    [APIS.holdings.funds.inquiry.getExpectedRedemption]: () => HolFndInqGetExpectedRedemption,
    [APIS.services.funds.expectedRedemption.executeTransferPre]: () => SvcFndErdValidateAccount,
    [APIS.services.funds.expectedRedemption.executeTransferMain]: () => SvcFndErdValidateAccount,
};
